import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Stream } from 'src/app/models/stream';

@Component({
  selector: 'app-stream-editor',
  templateUrl: './stream-editor.component.html',
  styleUrls: ['./stream-editor.component.scss']
})
export class StreamEditorComponent implements OnInit {
  public stream: Stream;

  constructor(
    public dialogRef: MatDialogRef<StreamEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { }

  ngOnInit() {
    this.stream = this.data.stream;
  }

  submit() {
    this.dialogRef.close(this.stream);
  }

  cancel(){
    this.dialogRef.close(false);
  }
}
